import { useCallback, useEffect } from 'react';
import { SET_LOGIN_STATUS } from '../context/actions';
import { getMyBeckhoffService } from '../../mybeckhoff/mybeckhoff';

export function useLogin(dispatch: any) {
  const setLoginStatus = useCallback(
    (status: boolean) => {
      dispatch({ type: SET_LOGIN_STATUS, loggedIn: status });
    },
    [dispatch],
  );

  const setLoggedIn = useCallback(() => {
    setLoginStatus(true);
  }, [setLoginStatus]);

  const setLoggedOut = useCallback(() => {
    setLoginStatus(false);
  }, [setLoginStatus]);

  useEffect(() => {
    const myBeckhoffService = getMyBeckhoffService();

    const onEvent = (event: string) => {
      if (event === 'SESSION_UPDATE') {
        setLoginStatus(myBeckhoffService.isLoggedIn);
      }
    };

    myBeckhoffService.subscribe(onEvent);

    return () => {
      myBeckhoffService.unsubscribe(onEvent);
    };
  }, [setLoggedIn, setLoggedOut, setLoginStatus]);

  return setLoginStatus;
}
